import React  from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import hydrofarm from "../../media/Photos/hydro.jpg";
import smartfarming from "../../media/Photos/Smart Farming.jpg";
import business from "../../media/Photos/business.jpg";

const Overview = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
    return(
        <div className="about-container">
          <div className="content-left">
          <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
        <h1 className="title">Brahma Jyoti Holdings Limited</h1>
        
        <section className="section">
          <h2 className="subtitle">Introduction</h2>
          <p>
            Brahma Jyoti Holdings Limited is a premier trading and investment company based in Nepal, dedicated to harnessing opportunities in both listed and non-listed stocks while also investing in sectors critical to sustainable development. Our strategic focus encompasses agriculture through our subsidiary, Brahma Jyoti Multi Agro Farm, and renewable energy through Brahma Jyoti Green Energy, which specializes in commercial solar plants and hydropower projects. With a commitment to fostering economic growth and environmental sustainability, Brahma Jyoti Holdings Limited aims to contribute significantly to Nepal's development landscape.
          </p>
        </section>
  
        <section className="section">
          <h2 className="subtitle">Core Business Activities</h2>
          <div style={{textAlign: 'center'}}>
        <img src={hydrofarm} alt="hydrofarm" width={300} />
        <img src={smartfarming} alt="smartfarming" width={300} />
        <img src={business} alt="smartfarming" width={300} />

        </div>
          <h3 className="small-title">Trading and Investment</h3>
        
          <p>
            Brahma Jyoti Holdings Limited engages in comprehensive trading operations, specializing in the procurement and distribution of a diverse array of products. Our investment strategy includes trading in both listed and non-listed stocks, allowing us to capitalize on market opportunities while providing our clients with access to a wide range of financial products.
          </p>
          <p>
            <strong>Investment Strategy:</strong> Our investment philosophy is centered on thorough market analysis and risk management, ensuring that we make informed decisions that align with our long-term goals. We seek to build a balanced portfolio that includes both growth and income-generating assets, contributing to financial stability and capital appreciation for our stakeholders.
          </p>
        </section>
  
       
        <section className="section">
          <h2 className="subtitle">Mission and Vision</h2>
          <p>
            <strong>Mission:</strong> At Brahma Jyoti Holdings Limited, our mission is to empower economic growth in Nepal through strategic trading and investment in agriculture and renewable energy. We are committed to fostering sustainable practices that enhance the quality of life for communities while generating value for our stakeholders.
          </p>
          <p>
            <strong>Vision:</strong> Our vision is to be a leading force in Nepal’s trading and investment landscape, recognized for our integrity, innovation, and commitment to sustainable development. We aspire to create a balanced ecosystem where economic prosperity and environmental stewardship coexist harmoniously.
          </p>
        </section>
  
        <section className="section">
          <h2 className="subtitle">Corporate Social Responsibility (CSR)</h2>
          <p>
            Brahma Jyoti Holdings Limited places a strong emphasis on corporate social responsibility. We believe that businesses have a duty to contribute positively to society and the environment. Our CSR initiatives include:
          </p>
          <ul>
            <li><strong>Educational Programs:</strong> Providing scholarships and educational resources to support local students and enhance their learning opportunities.</li>
            <li><strong>Sustainable Farming Workshops:</strong> Organizing training sessions for farmers to promote sustainable agricultural practices and improve productivity.</li>
            <li><strong>Community Health Initiatives:</strong> Supporting health programs that promote well-being and access to essential services in local communities.</li>
          </ul>
        </section>
  
        <section className="section">
          <h2 className="subtitle">Conclusion</h2>
          <p>
            Brahma Jyoti Holdings Limited stands at the intersection of trading, investment, agriculture, and renewable energy in Nepal. With a robust portfolio and a commitment to sustainable development, we are dedicated to making a meaningful impact in the communities we serve. As we continue to grow and innovate, our focus remains on enhancing the livelihoods of local populations while contributing to the overall economic development of Nepal. We envision a future where our endeavors lead to a thriving, sustainable economy that benefits all stakeholders.
          </p>
        </section>
      </div>
      </div>
    )
}


export default Overview;